import cn from 'classnames';
import { ReactElement } from 'react';

import styles from './Divider.module.scss';

export interface DividerProps {
  className?: string;
}

const Divider = ({ className }: DividerProps): ReactElement => {
  const styleClass = cn(className, styles.default);

  return <hr className={styleClass} />;
};

export default Divider;
